module.exports = __webpack_public_path__ + "static/search6-e29e37d3c7066e47e239c9b380a82222.png";